import { useEffect, useState } from "react";
import axios from "axios";
import { Quote, Star } from "lucide-react";

// Dealer testimonials about Prime Media Wireless (only admin-approved ones are returned)
export const DealerTestimonials = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/testimonials`).then((r) => setItems(r.data)).catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section className="py-16 bg-white" data-testid="dealer-testimonials">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="label-style text-teal mb-2">From our dealers</p>
        <h2 className="font-heading font-bold text-2xl sm:text-3xl text-navy mb-8">What Total Wireless dealers say about Prime Media</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((t) => (
            <figure key={t.id} className="rounded-2xl border border-slate-200 bg-slate-50 p-6" data-testid={`testimonial-${t.id}`}>
              <Quote className="w-6 h-6 text-teal mb-3" />
              <div className="flex gap-0.5 mb-2">{Array.from({ length: t.rating || 5 }).map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />)}</div>
              <blockquote className="text-slate-700 font-body text-sm mb-4">"{t.text}"</blockquote>
              <figcaption className="text-sm"><b className="text-navy">{t.author_name}</b>{t.author_title ? `, ${t.author_title}` : ""}{t.location_name ? <span className="text-slate-500"> · {t.location_name}</span> : null}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
